<div class="cmaLiteActivation modal inmodal fade in"
     [ngClass]="{ 'in': true }"
     aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button data-dismiss="modal"
                        (click)="confirmClose(confirmCloseTemplate)"
                        class="btn btn-primary btn-outline btn-lg pull-left"
                        type="button">
                    <i class="fa fa-arrow-left"></i>
                    <span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title"
                    [i18n]="'location-carrier-configuration.title'"></h4>
                <div></div>
            </div>
            <div class="modal-body">
                <div class="flex-row">
                    <div class="col _left">
                        <h2 [i18n]="'location-carrier-configuration.carrier-list.title'"></h2>
                        <app-data-table [columns]="carrierColumns"
                                        [sortColumn]="sortColumn"
                                        [direction]="SortDirection.ASC"
                                        [filtersComponent]="carriersDataFilters"
                                        [loadPage]="loadCarriersPage"
                                        [showColumnsSelection]="false">

                            <app-data-filters #carriersDataFilters
                                              [disableSearch]="carrierSearchDisabled()"
                                              [opened]="true" [fullWidth]="true">
                                <app-data-filter-group [useAvailableWidth]="true">

                                    <app-data-filter-input
                                        [labelKey]="'location-carrier-configuration.carrier-list.filters.vendor-number.title'"
                                        [(model)]="carrierFilters.vendorNumber"
                                        [helperKey]="'location-carrier-configuration.carrier-list.filters.vendor-number.tip'"
                                        [placeholderKey]="'location-carrier-configuration.carrier-list.filters.vendor-number.placeholder'"></app-data-filter-input>


                                    <app-data-filter-input
                                        [labelKey]="'location-carrier-configuration.carrier-list.filters.name.title'"
                                        [(model)]="carrierFilters.name"
                                        [helperKey]="'location-carrier-configuration.carrier-list.filters.name.tip'"
                                        [placeholderKey]="'location-carrier-configuration.carrier-list.filters.name.placeholder'"></app-data-filter-input>


                                </app-data-filter-group>

                            </app-data-filters>

                        </app-data-table>
                        <ng-template #carrierName let-item="item" let-carrierName="name">
                            <span class="rowName">{{ carrierName }}</span>
                        </ng-template>
                        <ng-template #vendorNumber let-item="item" let-vendorNumber="vendorNumber">
                            <span class="rowName">{{ vendorNumber }}</span>
                        </ng-template>
                        <ng-template #enableCmaLiteColumn let-item="item">
                            <button type="button" class="btn btn-transfert-col btn-primary"
                                    *ngIf="!itemAdded(item) && !itemMissingInfo(item)"
                                    (click)="addCarrier(item)">
                                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            </button>

                            <a class="infoTip" [title]="getLabel('location-carrier-configuration.carrier-list.info.no-vendor-number')"><i *ngIf="itemMissingInfo(item)"
                                                               class="fa fa-info-circle"></i>
                            </a>

                            <a class="infoTip _check" [title]="getLabel('location-carrier-configuration.carrier-list.info.added')">
                                <i *ngIf="itemAdded(item)" class="fa fa-check"></i>
                            </a>
                        </ng-template>
                    </div>

                    <div class="col _right">
                        <section class="container-fluid flex-column grow">
                            <h2 [i18n]="'location-carrier-configuration.config-list.title'"></h2>
                            <app-data-filters [disableSearch]="configSearchDisabled()" #configDataFilters
                                              [opened]="true" [fullWidth]="true">
                                <app-data-filter-group [useAvailableWidth]="true">

                                    <app-data-filter-input
                                        [labelKey]="'location-carrier-configuration.carrier-list.filters.vendor-number.title'"
                                        [(model)]="configFilters.vendorNumber"
                                        [helperKey]="'location-carrier-configuration.carrier-list.filters.vendor-number.tip'"
                                        [placeholderKey]="'location-carrier-configuration.carrier-list.filters.vendor-number.placeholder'"></app-data-filter-input>

                                    <app-data-filter-input
                                        [labelKey]="'location-carrier-configuration.carrier-list.filters.name.title'"
                                        [(model)]="configFilters.name"
                                        [helperKey]="'location-carrier-configuration.carrier-list.filters.name.tip'"
                                        [placeholderKey]="'location-carrier-configuration.carrier-list.filters.name.placeholder'"></app-data-filter-input>

                                </app-data-filter-group>

                            </app-data-filters>

                            <div class="ibox float-e-margins" style="margin-top: 30px;">
                                <div class="ibox-content no-padding">
                                    <div class="table-responsive list">
                                        <table class="table table-striped text-left">
                                            <thead>
                                            <tr>
                                                <th width="54"
                                                    [i18n]="'location-carrier-configuration.config-list.remove'"></th>
                                                <th [i18n]="'location-carrier-configuration.config-list.name'"></th>
                                                <th [i18n]="'location-carrier-configuration.config-list.vendor-number'"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr *ngFor="let configuredCarrier of configuredCarriersToDisplayFiltered"
                                                class="scrollable-list">
                                                <td>
                                                    <div class="text-right">
                                                        <button type="button" class="btn btn-transfert-col btn-danger"
                                                                (click)="removeCarrier(configuredCarrier)">
                                                            <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <span>{{configuredCarrier.name}}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <span>{{configuredCarrier.vendorNumber}}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button data-dismiss="modal"
                        class="btn btn-lg btn-i btn-primary pull-right"
                        [ngClass]="'btn-save'"
                        type="button"
                        [disabled]="addedCarriers.length === 0 && removedCarriers.length === 0"
                        (click)="confirmUpdateLocationCarrierConfig(confirmLocationCarrierConfiguration)">
                    <i class="fa fa-save"></i>
                    <span [i18n]="'location-carrier-configuration.save'"></span>
                </button>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in"></div>
</div>

<ng-template #confirmLocationCarrierConfiguration
             let-c="close" let-d="dismiss">
    <div *ngIf="addedCarriers.length">
        <h2 *ngIf="addedCarriers.length > 1" [i18n]="[{target: 'innerHTML', key: 'location-carrier-configuration.modals.confirm.carriers-added', params: { size: addedCarriers.length}}]"></h2>
        <h2 *ngIf="addedCarriers.length === 1" [i18n]="'location-carrier-configuration.modals.confirm.carrier-added'"></h2>
        <ul>
            <li *ngFor="let carrier of addedCarriers">{{ carrier.name }}</li>
        </ul>
    </div>
    <div *ngIf="removedCarriers.length">
        <h2 *ngIf="removedCarriers.length > 1" [i18n]="[{target: 'innerHTML', key: 'location-carrier-configuration.modals.confirm.carriers-removed', params: { size: removedCarriers.length}}]"></h2>
        <h2 *ngIf="removedCarriers.length === 1" [i18n]="'location-carrier-configuration.modals.confirm.carrier-removed'"></h2>
        <ul>
            <li *ngFor="let carrier of removedCarriers">{{ carrier.name }}</li>
        </ul>
    </div>
</ng-template>

<ng-template #confirmCloseTemplate let-c="close" let-d="dismiss">
    <span [i18n]="'location-carrier-configuration.modals.dirty-check.content'"></span>
</ng-template>


<app-modal #dedicatedModalComponent [orphan]="true"></app-modal>
